import { Language } from "./languages";

let currentLanguage = Language.Nederlands;
export const setCurrentLanguage = (language: Language) => {
  currentLanguage = language;
};
export const getCurrentLanguage = (): Language => currentLanguage;

export class Translator {
  private translationRegistry: {
    [key: string]: {
      [key: string]: string;
    };
  } = {};

  private replaceProperties = (value: string, properties: { [key: string]: string }): string => {
    if (Object.keys(properties).length > 0) {
      Object.keys(properties).forEach((translationKey) => {
        value = value.replace(`{{${translationKey}}}`, properties[translationKey]);
      });
    }

    return value;
  };

  translate = (key: string, properties: { [key: string]: string } = {}): string => {
    let value: string = this.translationRegistry?.[currentLanguage]?.[key];

    if (value === undefined) {
      value = key;
    }

    return this.replaceProperties(value, properties);
  };

  registerTranslations = (locale: Language, translations: { [key: string]: string }): void => {
    if (locale) {
      this.translationRegistry[locale] = { ...translations, ...this.translationRegistry[locale] };
    }
  };
}
